module.exports = __webpack_public_path__ + "static/gallery8-8f79a8628f27018881e05bcaabd6ebf6.png";